
export default {
  props: {
    component: {
      type: Object,
      default() {
        return {
          text: '<h2>Ihre Aufgabe</h2><p>Sie als dynamische, zielorientierte <strong>Persönlichkeit</strong> mit handwerklichem Geschick, Selbstdisziplin, Kontaktfreudigkeit und Ehrgeiz pflegen unsere bestehenden <a title="Beam mich hoch" href="https://novu.ch">Kundenbeziehungen</a>, bauen diese aus und <em>akquirieren Neukunden</em>.</p><h2>Ihr Profil</h2><ul><li><p>Ausbildung als Detailhandelsfachmann/-fachfrau</p></li><li><p>Branchenerfahrung erwünscht</p></li><li><p>Idealalter 25 – 45 Jahre mit PW-Führerausweis</p></li><li><p>Gute EDV-Kenntnisse und Organisationstalent</p></li></ul><h2>Unsere Leistungen</h2><ol start="1"><li><p>Interessante Verdienstmöglichkeiten und Spesenentschädigung</p></li><li><p>Firmenfahrzeug und moderne Arbeitsinstrumente</p></li><li><p>Grosser Kundenstamm vorhanden</p></li></ol>',
          background_color: {
            value: 'gray-light',
          },
        }
      },
    },
  },
}
